var map = {
	"./0.png": "ad20",
	"./1.png": "2948",
	"./2.png": "82d9",
	"./3.png": "7f0c",
	"./4.png": "371a",
	"./5.png": "44b8",
	"./6.png": "0827",
	"./apple-watch.png": "4400",
	"./arrow.png": "2b7d",
	"./beats-headphones.png": "429b",
	"./decore-left.png": "962e",
	"./decore-right.png": "4bd2",
	"./homepod.png": "426c",
	"./ipad-pro.png": "f647",
	"./iphone-x.png": "10bb",
	"./jbl-speaker.png": "9741",
	"./macbook-pro.png": "9d36",
	"./magic-mouse.png": "e8ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a212";